export default __webpack_public_path__ + "static/media/lt.ccd9e1fe.jpg";